import * as React from "react";
const SvgIcLaptop = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M2 19V4H22V19H24V22H0V19H2ZM19 16H5V7H19V16Z" fill="currentColor" /></svg>;
export default SvgIcLaptop;